import { useStomp } from '@repo/network'
import { messaging } from '@web/firebase'
import { NotificationPayload } from '@repo/types'
import { getToken, onMessage } from 'firebase/messaging'
import { useEffect, useState } from 'react'
import { NotificationService } from '@web/notifications/NotificationService'

export const useNotificationStartup = () => {
  const { stomp } = useStomp()
  const [showModal, setShowModal] = useState(false)

  const requestPermissionNotification = async () => {
    const permission = await Notification.requestPermission()
    if (permission === 'granted') {
      try {
        const token = await getToken(messaging, {
          vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY
        })
        NotificationService.startNotificationService(token).then()
      } catch (e) {
        console.error('[Notification]', e)
      }
    }
  }

  useEffect(() => {
    if (import.meta.env.VITE_APP_PROFILE !== 'development') {
      requestPermissionNotification().then()
      navigator.permissions.query({ name: 'notifications' }).then(permissionStatus => {
        permissionStatus.onchange = () => {
          if (permissionStatus.state === 'denied') {
            setShowModal(true)
          }
        }
      })
    }
  }, [])

  onMessage(messaging, payload => {
    if (payload.notification) {
      const { connectionKey, phoneNumber } = JSON.parse(String(payload?.data?.payload)) as NotificationPayload

      if (!stomp?.isChatActive(connectionKey, phoneNumber)) {
        // eslint-disable-next-line no-new
        new Notification(String(payload.notification.title), {
          body: String(payload.notification.body)
        })
      }
    }
  })
  return {
    showModal,
    setShowModal
  }
}
